var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8RedimensionnerEnDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.99285,0.03455) rotate(90) scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4707,6.98633c-0.05359,0.00169 -0.10705,0.00626 -0.16016,0.01367h-13.81055c-0.54095,-0.00765 -1.04412,0.27656 -1.31683,0.74381c-0.27271,0.46725 -0.27271,1.04514 0,1.51238c0.27271,0.46725 0.77588,0.75146 1.31683,0.74381h10.37891l-25.87891,25.87891v-10.37891c0.00582,-0.40562 -0.15288,-0.7963 -0.43991,-1.08296c-0.28703,-0.28666 -0.67792,-0.44486 -1.08353,-0.43852c-0.82766,0.01293 -1.48844,0.69381 -1.47656,1.52148v13.77734c-0.07778,0.47616 0.07819,0.96067 0.41916,1.30202c0.34096,0.34135 0.8253,0.49788 1.30155,0.42063h13.7793c0.54095,0.00765 1.04412,-0.27656 1.31683,-0.74381c0.27271,-0.46725 0.27271,-1.04514 0,-1.51238c-0.27271,-0.46725 -0.77588,-0.75146 -1.31683,-0.74381h-10.37891l25.87891,-25.87891v10.37891c-0.00765,0.54095 0.27656,1.04412 0.74381,1.31683c0.46725,0.27271 1.04514,0.27271 1.51238,0c0.46725,-0.27271 0.75146,-0.77588 0.74381,-1.31683v-13.82617c0.05483,-0.43431 -0.08278,-0.87091 -0.37674,-1.19529c-0.29397,-0.32438 -0.71495,-0.50416 -1.15255,-0.49221z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RedimensionnerEnDiagonal);
export default __webpack_public_path__ + "static/media/icons8-redimensionner-en-diagonal.358b87a3aa66119168029e3c7738ad56.svg";
export { ForwardRef as ReactComponent };